// English texts. French lives in fr.js; any key missing there falls back to this file.
export default {
  "meta": {
    "title": "Gilbert Trinidad, Product Designer / Builder",
    "description": "Product designer / builder in Paris. I design web products and ship them by directing Claude Code."
  },
  "lang": {
    "fr": "Français",
    "en": "English"
  },
  "nav": {
    "projects": "Projects",
    "contact": "Contact me",
    "about": "About",
    "cv": "CV",
    "homeLabel": "Gilbert Trinidad, home",
    "services": "Services",
    "openMenu": "Open menu",
    "closeMenu": "Close menu",
    "menu": "Menu",
    "downloadCv": "Download my CV",
    "bookCall": "Book a free call"
  },
  "hero": {
    "hello": "Hi, I'm",
    "title": "Product Designer",
    "text": "I design web products and ship them with a team of Claude agents I built. I lead the research and the design decisions, direct the AI and check every deliverable.",
    "seeWork": "See my work",
    "contact": "Get in touch",
    "book": "Book a free 30-min call",
    "talk": "Let's talk about your project",
    "trusted": "Trusted by coaches and therapists in Paris",
    "mockupAlt": "SPCoach website, desktop and mobile",
    "available": "Open to Product Designer roles · Paris",
    "h1a": "Hi, I'm Gilbert,",
    "h1b": "Product Designer / Builder",
    "chips": {
      "research": "UX research",
      "wireframes": "Wireframes",
      "prototyping": "Code prototypes",
      "ui": "Design system",
      "ai": "Claude Code",
      "launch": "Launch"
    }
  },
  "work": {
    "title": "Selected work",
    "intro": "Two coaching websites I designed, and two platforms: a concept and a client product."
  },
  "testimonials": {
    "title": "What clients say",
    "seeProject": "See the project →",
    "sophie": {
      "job": "Coach and therapist",
      "quote": "Gilbert designed my website and wrote its copy. He took the time to understand my work and my clients, who are often anxious about taking the first step. The result is a warm, clear site that feels like me and makes booking a session easy.",
      "pullStart": "“A warm, clear site ",
      "pullEnd": "that feels like me",
      "pullAfter": ".”"
    },
    "melodie": {
      "job": "Career coach and psychopractitioner",
      "quote": "My two services, career assessment and therapy, are very different. Gilbert understood that right away and gave each one its own clear path, with words that stay gentle, like my practice. Now visitors find the right service and book a discovery call easily.",
      "pullStart": "“Visitors ",
      "pullEnd": "find the right service",
      "pullAfter": ".”"
    },
    "subtitle": "Two Paris coaches on how we designed their websites together."
  },
  "skills": {
    "count": "Count",
    "title": "What I do",
    "ux": {
      "step": "Listen",
      "name": "Understand and decide",
      "description": "I start with users: who they are, what holds them back, what they need. Then I choose between options and build a journey that guides them step by step, so the next move is always obvious.",
      "tags": "UX research | User journeys | Trade-offs"
    },
    "ui": {
      "step": "Picture the choreo",
      "name": "Design the system",
      "description": "I drive Claude connected to Figma: it generates wireframes, mockups and prototypes directly in Figma, on an up-to-date design system so every screen finds the right rhythm.",
      "tags": "Design system | Claude + Figma | Wireframes | Prototypes"
    },
    "proto": {
      "step": "Step into the cypher",
      "name": "User-test the prototypes",
      "description": "I put my prototypes in front of real users, on a video call or through a simple link: the prototype opens right in the browser, with nothing to install. I watch where they hesitate and adjust before anything gets built. The circle's reaction tells me whether the journey holds up.",
      "tags": "User testing | Figma prototypes | Zoom | Iterations"
    },
    "test": {
      "step": "Rehearse",
      "name": "Test and refine",
      "description": "I define what needs checking, and my QA and accessibility agents check it: links, FR/EN translations, contrast, keyboard navigation. I review each point on mobile and desktop, then decide what must be fixed before launch.",
      "tags": "QA | Accessibility | Claude agents | Mobile review"
    },
    "dev": {
      "step": "Take the stage",
      "name": "Automate the build",
      "description": "Claude Code builds what I design. I set the direction, follow every change closely, and nothing goes live without my sign-off: good follow-through leads to good staging.",
      "tags": "Claude Code | AI agents | Vue / Tailwind | Vercel"
    },
    "subtitle": "From the problem to a live product: I decide, AI speeds things up, I check everything.",
    "tools": "My tools:"
  },
  "about": {
    "title": "About",
    "p2": "My approach: understand users, make the offer easy to grasp, and remove everything that slows down the decision. I show my choices and what I ruled out, not just the result.",
    "cv": "Download my CV",
    "p1Start": "I'm Gilbert, a ",
    "p1Highlight": "product designer",
    "p1End": " in Paris with a background in web development. I build my own workflow and Claude agents, a small product team: research, design, copy, code and testing. I take the lead: I set the direction, make the calls and check every deliverable before it goes live.",
    "cta": "Get in touch",
    "chip1": "Design + copywriting",
    "chip2": "From problem to live product"
  },
  "case": {
    "resultLabel": "Outcome",
    "contactTitle": "Want to talk about it?",
    "contactText": "I'll walk you through my choices and what I set aside on this project.",
    "nextLabel": "Next project",
    "client": "Client:",
    "role": "Role:",
    "tools": "Tools:",
    "goTo": "Go to {name}",
    "sections": {
      "context": "Context",
      "challenge": "The challenge",
      "approach": "Approach",
      "solution": "Solution",
      "outcome": "Outcome",
      "decisions": "Decisions and trade-offs",
      "retro": "Looking back"
    },
    "back": "Back",
    "atAGlance": "At a glance",
    "clientLabel": "Client",
    "roleLabel": "Role",
    "typeLabel": "Type",
    "toolsLabel": "Tools",
    "contents": "Contents",
    "similarTitle": "A similar project?",
    "similarText": "Let's talk about your site in a free 30-minute call.",
    "similarCta": "Book a call"
  },
  "projects": {
    "1": {
      "label": "Client project",
      "hook": "Website for a Paris coach: from first visit to booked session",
      "tagline": "A site built from scratch that brings clients to Sophie",
      "result": "Clients now reach Sophie through the site",
      "client": "Sophie Pratt, coach and therapist, Paris",
      "role": "UX/UI design in Figma and copywriting",
      "tools": "Figma",
      "visit_label": "Visit spcoach.fr",
      "sections": {
        "context": "Sophie offers personal coaching, business coaching and therapy for social anxiety, in Paris and online. She had no website yet. Many of her future clients are anxious about taking the first step, so the site had to feel safe before it could sell anything.",
        "challenge": "Three different offers, three different audiences, and visitors who hesitate to reach out. They needed to understand quickly what Sophie does, whether it's for them, how it works and what it costs, without feeling pushed.",
        "decisions": "1. A free 30-minute discovery call. For visitors who dread the first step, a no-commitment chat is easier to take than a paid session.\n2. The 8-session package up front. It is flagged as the popular offer with the saving shown, guiding people towards the full programme without hiding the single session.\n3. A structure that follows the visitor's questions: what is it, is it for me, how does it work, what does it cost, who is she. I wrote the copy alongside the structure, with Sophie's input, and the FAQ and trust signals (Sorbonne, Qualiopi) round out the journey.\n4. Designs ready for development. I designed the site in Figma, and a developer built it on WordPress from my designs.",
        "outcome": "The site is live and Sophie uses it to present her offers and take bookings. Clients have contacted her thanks to the site. In her words: \"The result is a warm, clear site that feels like me and makes booking a session easy.\"",
        "retro": "I didn't use AI on this project. Today I would redo it all with Claude, from design to launch."
      },
      "type": "Showcase site · Booking",
      "screens": {
        "intro": {
          "title": "Introduction"
        },
        "pricing": {
          "title": "Pricing"
        },
        "confirmation": {
          "title": "Confirmation page"
        }
      }
    },
    "2": {
      "label": "Client project",
      "hook": "Two services, one clear path to a discovery call",
      "tagline": "A site built from scratch that makes visitors want to contact Mélodie",
      "result": "Clients now reach Mélodie through the site",
      "client": "Mélodie Yeremian, career coach and psychopractitioner, Paris and remote",
      "role": "Design in Figma and site build (WordPress, Divi)",
      "tools": "Figma, WordPress, Divi Builder, Claude",
      "visit_label": "Visit melodieyeremian.com",
      "sections": {
        "context": "Mélodie supports people through professional and personal transitions with two distinct services: career assessments (bilan de compétences) and therapeutic support. She had no website yet: everything started from scratch.",
        "challenge": "The two services meet very different needs. Visitors had to find theirs quickly, without confusing a career assessment with therapy, and feel confident enough to book a first appointment. Two constraints framed the project: Mélodie had to be able to edit her site on her own, and the tone had to stay gentle, true to her practice.",
        "decisions": "1. Two separate paths rather than one shared page. Each service has its own page, details and discovery booking.\n2. WordPress and Divi Builder rather than a custom-coded site. I put Mélodie's autonomy first and accepted less freedom over interface details.\n3. Turning the client's requests into interface. The always-visible \"Book an appointment\" bar, a discovery button for each service and a low-key shop came from Mélodie. My role was to build them in without weighing down the journey.\n4. A personal \"About me\" section, because in therapy as in career coaching, people choose a person first.",
        "outcome": "The site is live and Mélodie uses it to present both services and take bookings. Since launch, clients have contacted her after discovering her site. In her words: \"Now visitors find the right service and book a discovery call easily.\"",
        "retro": "I didn't use AI to build this site. Today I would start directly with Claude instead of installing and setting up WordPress by hand. So I built a workflow that connects the site to Claude: future changes to WordPress, Divi and the plugins are made by asking Claude, without going through the WordPress admin. It's ready and being installed on Mélodie's Claude account, so she can run her site on her own."
      },
      "type": "Showcase site · Shop",
      "screens": {
        "services": {
          "title": "Services"
        },
        "pricing": {
          "title": "Pricing"
        },
        "shop": {
          "title": "Shop"
        }
      }
    },
    "3": {
      "label": "Concept project",
      "hook": "Booking platform for unusual stays",
      "description": "Atypikhouse is a concept for a rental platform dedicated to unusual stays. I designed the desktop and mobile experience to help people find a quiet getaway and book it easily.",
      "type": "Web & mobile platform",
      "screens": {
        "homeDesktop": {
          "title": "Home on desktop"
        },
        "homeMobile": {
          "title": "Home on mobile"
        }
      }
    },
    "4": {
      "label": "Client project",
      "hook": "Learning platform with crypto-paid courses",
      "description": "Unfate is a learning platform built around one idea: everything you need on a subject in one place, so you don't have to piece it together from across the web. Courses are paid in cryptocurrency. Working with the founding team, I designed the main flows: login, settings, practice and exams. The product has since been discontinued.",
      "type": "Web app",
      "screens": {
        "login": {
          "title": "Sign-in"
        },
        "settings": {
          "title": "Settings"
        },
        "practice": {
          "title": "Practice"
        },
        "examInstructions": {
          "title": "Exam instructions"
        },
        "nextQuestion": {
          "title": "Next question"
        },
        "examPassed": {
          "title": "Exam passed"
        }
      }
    }
  },
  "contact": {
    "title": "Let's talk",
    "subtitle": "Hiring a product designer? Drop me a line, I'll get back to you shortly.",
    "preferTalk": "Prefer to talk? Book a free 30-min call",
    "or": "or send a message",
    "name": "Name",
    "email": "Email",
    "message": "Tell me about your project",
    "send": "Send message",
    "sending": "Sending…",
    "success": "Thanks! I'll get back to you within 48h.",
    "errorBefore": "Something went wrong. Please try again or reach me on",
    "privacyNote": "Your details are only used to reply to you.",
    "privacy": "Privacy policy",
    "copyright": "© 2026 Gilbert Trinidad"
  },
  "privacy": {
    "title": "Privacy policy",
    "text": "This website doesn't use advertising cookies. The details you send through the contact form (name, email, message) are only used to reply to you and are never shared with third parties."
  },
  "strip": {
    "alt": "{name} project, {screen} screen",
    "label": "Project screens",
    "screens": {
      "pricing": "pricing",
      "confirmation": "confirmation",
      "services": "services",
      "shop": "shop",
      "home": "home"
    }
  },
  "gallery": {
    "title": "Screens",
    "hint": "Click a screen to enlarge it",
    "open": "Enlarge: {title}"
  },
  "viewer": {
    "close": "Close",
    "previous": "Previous screen",
    "next": "Next screen",
    "scrollHint": "Scroll to see the whole page",
    "work": "Work"
  },
  "notFound": {
    "title": "Page not found",
    "text": "This page doesn't exist or has moved.",
    "projects": "See my projects",
    "home": "Back to home"
  }
}
